const theme = {
    white: '#ffffff',
    textColor: '#342B44',
    textColorLight: '#636363',
    headerColor: '#595560',
    primary: '#583e8d',
    primaryLight: '#E5D9FC',
    primaryHighlight: '#C6B4E9',
    secondary: '#BBE7B4',
    backgroundColor: '#E1DFE4',
    lightBackground: '#F1EFF3',
  
    bodyFont: "'Titillium Web', sans-serif",
    serifFont: "'Amaranth', serif",
    headerFont: "'Amaranth'",
  
    paddingSize: 20,
  };
  
  export default theme;
  


// WEBPACK FOOTER //
// ./src/theme/index.js